export default __webpack_public_path__ + "static/breeo-outpost-grill-with-bag-8a543470a3a53ad38181c7fe500c9a36.jpg";